import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const TRANS_KEY = 'ADD_COMPANY.FORM_ERRORS';

const formSchema = z.object({
  name: z
    .string()
    .min(1, { message: t(`companies:${TRANS_KEY}.NAME_REQUIRED`) }),
  shortname: z.string(),
  website: z.string(),
  vatId: z.string(),
  categories: z.array(z.string()),
  address: z.object({
    street: z.string(),
    addition: z.string(),
    zip: z.string(),
    city: z.string(),
    country: z.string(),
  }),
  contact: z.object({
    phone: z.string(),
    fax: z.string(),
    email: z
      .string()
      .trim()
      .email({ message: t(`companies:${TRANS_KEY}.EMAIL_INVALID`) })
      .or(z.literal('')),
  }),
});

export type AddCompanyFormSchemaType = z.infer<typeof formSchema>;

const defaultValues: AddCompanyFormSchemaType = {
  name: '',
  shortname: '',
  website: '',
  vatId: '',
  categories: [],
  address: {
    street: '',
    addition: '',
    zip: '',
    city: '',
    country: 'DE',
  },
  contact: {
    phone: '',
    fax: '',
    email: '',
  },
};

type UseAddCompanyFormReturnType = UseFormReturn<AddCompanyFormSchemaType>;

export const useAddCompanyForm = (): UseAddCompanyFormReturnType =>
  useForm<AddCompanyFormSchemaType>({
    defaultValues,
    resolver: zodResolver(formSchema),
  });
